import SelectBox from "@scripts/components/selectbox";
import Page from "@scripts/page";
import ContactImage from '@/images/svg/location.svg';

export default class Events extends Page {
    $missionTypes: HTMLElement;
    $missionSelectBox: SelectBox;
    $mois: HTMLElement;
    $moisSelectBox: SelectBox;
    currentUrl: string;
    urlParams: URLSearchParams;

    constructor() {
        super();

        const $listEvents = document.querySelectorAll('.list-events');
        this.$missionTypes = <HTMLElement>document.querySelector('.select-box.select-mission-types');
        this.$missionSelectBox = new SelectBox(this.$missionTypes);
        this.$mois = <HTMLElement>document.querySelector('.select-box.select-mois');
        this.$moisSelectBox = new SelectBox(this.$mois);
        this.currentUrl = location.href.split('?')[0];
        this.urlParams = new URLSearchParams(location.href.split('?')[1]);
        if (this.$missionTypes) {
            (<HTMLElement>this.$missionSelectBox.$container).addEventListener(this.$missionSelectBox.ON_CHANGE, (event: Event) => {
                this.gotoMission((<CustomEvent>event).detail);
            });

            (<HTMLElement>this.$moisSelectBox.$container).addEventListener(this.$moisSelectBox.ON_CHANGE, (event: Event) => {
                this.gotoMois((<CustomEvent>event).detail);
            });
        }

        $listEvents.forEach($list => {
            this.updateImageDimensions( <HTMLElement>$list, '.list-events .thumbnail img');
        });

        this.setCurrentUrlClass();
    }

    setCurrentUrlClass() {
        // console.log(location);
        if (location.pathname.indexOf('evenement') != -1) {
            const $eventLink = document.querySelector<HTMLAnchorElement>('.main-navigation .menu-item a[href="/evenement/"]');
            const $eventLinkParent = (<HTMLAnchorElement>$eventLink).parentNode;

            (<HTMLElement>$eventLinkParent).classList.add('current-menu-item');
        }
    }

    goToFilter(name: string, value: string) {
        if (value !== '0') {
            this.urlParams.set(name, value);
            location.href = this.currentUrl + '?' + this.urlParams.toString();
        } else {
            this.urlParams.delete(name);
            if (this.urlParams.toString() !== '') {
                location.href = this.currentUrl + '?' + this.urlParams.toString();
            } else {
                location.href = this.currentUrl;
            }
        }
    }

    gotoMission (detail: Record<string, number>) {
        this.goToFilter('mission', detail.value.toString());
    }

    gotoMois (detail: Record<string, number>) {
        this.goToFilter('mois', detail.value.toString());
    }
}
